import { forwardRef } from 'react'
import { Box, H1, H4, Pill, TextSpinner } from '.'
import { expertise, indexFromValue } from '../../lookups'
import { useDelay } from '@10000/react'

export const Expertise = forwardRef(function Expertise({ title, value, change, color = 'white', column = true, valueSize, expertiseSize, animate, showValue = true, ...props }, ref) {
  const showStats = useDelay(500)

  return (
    <Box
      column={column}
      alignItems={column ? 'center' : 'space-between'}
      gap={16}
      ref={ref}
      {...props}
    >
      {title &&
        <H4
          color={color}
          align={column ? 'center' : 'start'}
          style={{ flexGrow: 1 }}
        >
          {title}
        </H4>
      }

      <H1
        color={color}
        size={(showStats || !animate) ? valueSize : 1}
        lineHeight={0.8}
        style={{ flexGrow: 1, transition: '0.5s' }}
      >
        {(value !== undefined && value !== null && !isNaN(value) && showValue) ? value.toFixed(1) : <><br/></>}
      </H1>

      <Box
        column
        grow
        gap={8}
        alignItems={column ? 'center' : 'end'}
      >
        <TextSpinner
          items={expertise.map(x => x.toUpperCase())}
          selectedIndex={indexFromValue(value)}
          size={expertiseSize}
          delay={animate ? 500 : 0}
          duration={animate ? 2 : 0}
        />

        {(change !== undefined && change !== null) &&
          <Pill
            background="rgba(255, 255, 255, 0.55)"
            color={change > 0 ? 'var(--blue)' :  change < 0 ? 'var(--red)' : 'white'}
            leftIcon={change > 0 ? 'ChevronUp' : change < 0 ? 'ChevronDown' : undefined}
            height={32}
            pr={16}
            pl={change === 0 ? 16 : 6}
          >
            {change.toFixed(1)}%
          </Pill>
        }
      </Box>
    </Box>
  )
})
